var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "3.5 3 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.134 9.487a6.63 6.63 0 1 0-8.971 8.505 6.631 6.631 0 0 0 8.017-1.855.685.685 0 1 1 1.072.855 8.002 8.002 0 0 1-14.076-6.665 8.003 8.003 0 0 1 12.657-4.702 7.999 7.999 0 0 1 1.794 1.894V4.687a.686.686 0 0 1 1.372 0v5.485a.685.685 0 0 1-.686.686H14.74a.686.686 0 0 1 0-1.371h3.393z"
  })));
};
export default SvgRefresh;